<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../assets/images/patch/contactUsBg.png">
    </div>
    <div class="bgMobileImageWrap">
        <img src="../../../assets/images/contactMobile.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
                Contact Us
            </div>
        </div>
    </div>
</div>


<div class="service-provider">


<!--     <div class="mainSection">
        <div class="navSection">
            <ul>
                <li>
                    <span (click)="onChange('service')" [ngClass]="'service' === activeElement ? 'active' : 'none'" >
                        Request for services
                    </span>
                </li>
                <li>
                    <span (click)="onChange('team')" [ngClass]="'team' === activeElement ? 'active' : 'none'" >
                        Join our team
                    </span>
                </li>
            </ul>
        </div>
        <div class="lineWrap">

        </div>
        <div class="formSection">
            <div class="formWrap">
                <div class="titleAccOption">
                    {{_getTitle()}}
                </div>
                <div class="mainWrapForFormData">


                    <form class="example-form" *ngIf="services">
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>First Name</mat-label>
                                <input matInput >
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Last Name</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Phone</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Experience</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Skill</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Location</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>

                        <div class="buttonWrapForm">
                            <button>
                                Submit Now
                            </button>
                        </div>
                    </form>

                    <form class="example-form" *ngIf="!services">
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>First Name</mat-label>
                                <input matInput >
                            </mat-form-field>
                        </div>
                        <div class="fName">
                            <mat-form-field class="example-full-width">
                                <mat-label>Last Name</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fullName">
                            <mat-form-field class="example-full-width full">
                                <mat-label>Business Email</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fullName">
                            <mat-form-field class="example-full-width full">
                                <mat-label>Phone</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fullName">
                            <mat-form-field class="example-full-width full">
                                <mat-label>Company  </mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>
                        <div class="fullName">
                            <mat-form-field class="example-full-width full">
                                <mat-label>Requirement</mat-label>
                                <input matInput>
                            </mat-form-field>
                        </div>

                        <div class="buttonWrapForm">
                            <button>
                                Submit Now
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
 -->



    <div class="mainWrap">
        <div class="headerSection">
            <div class="titleWrap">
                Explore your ideas with us!
            </div>
        </div>
        <div class="bodySection">
            <div class="nameWrapContact">
                <span>
                    <img class="iconContactDetails" src="../../../assets/images/patch/name.svg">
                </span>
                <span class="textbottomSpan">
                    Nitin Bansal
                </span>
            </div>
            <div class="mobileNumberWrap">
                <span>
                    <a href="tel:+919654854895">
                        <img class="iconContactDetails" src="../../../assets/images/patch/call.svg">
                    </a>
                </span>
                <span class="textbottomSpan">
                    <a href="tel:+919654854895" style="color: #000;">
                        +91-9654854895
                    </a>
                </span>
            </div>
            <div class="addressWrap">
                <span>
                    <img class="iconContactDetails" src="../../../assets/images/patch/location.svg">
                </span>
                <span class="textbottomSpan">
                    91springboard, Building Number 145, Sector 44 Rd, Sector 44, Gurgaon - 122003
                </span>
            </div>

        </div>
    </div>

    <div class="writeEmailWrap">
        <div class="emailBottomWrap">
            <div class="imageWrapBottomEmail">
                <img src="../../../assets/images/patch/mail.svg">
            </div>
            <div class="textWrapBottomEmail">
                Write to Us
            </div>
            <div class="buttonWrapBottomEmail">
                <button>
                    <a class="remove" href="mailto:contactus@patchinfotech.com">
                    contactus@patchinfotech.com
                 </a>
                </button>
            </div>
        </div>
    </div>
</div>